import { EPartitionCadence } from '../../filters/types-filters';
import { EIncentiveType, TParticipation } from './types-participation-details';

export const transformParticipationDetails = (response: TParticipation): TParticipation | undefined => {
  if (!response) {
    return undefined;
  }
  return {
    ...response,
    coreParticipations: response.coreParticipations.map((coreParticipation) => {
      const { availablePartitions = [] } = coreParticipation;
      const isUbi = coreParticipation?.payMixDetails?.incentiveType === EIncentiveType.UBI;
      const enabledPartitionCadences = {
        [EPartitionCadence.Quarterly as string]: !isUbi,
        [EPartitionCadence.SemiAnnual as string]: true,
        [EPartitionCadence.Monthly as string]: true,
      };
      return {
        ...coreParticipation,
        availablePartitions: availablePartitions
          .filter((partitionGroup) => enabledPartitionCadences[partitionGroup.partitionCadence as string])
          .map((partitionGroup) => ({
            ...partitionGroup,
            partitions:
              partitionGroup.partitions?.map((partition) => ({
                ...partition,
                // strip commas from title, so that partitions like "June, 2025" play nice with Harmony Combobox
                title: typeof partition.title === 'string' ? partition.title.replace(',', '') : partition.title,
              })) || [],
          })),
      };
    }),
  };
};
